import isNumber from './is-number';
/**
 * 判断值是否为有限数
 * @return 是否为有限数
 */
export default function (value) {
    return isNumber(value) && isFinite(value);
}
//# sourceMappingURL=is-finite.js.map